export const QUERY_CONFIGS = {
  limit: 25,
};
